import React from 'react'
import AccountMenuLoyaltyNoAccountBronzeTile from './AccountMenuLoyaltyNoAccountBronzeTile'
import AccountMenuLoyaltyNoAccountSilverTile from './AccountMenuLoyaltyNoAccountSilverTile'
import AccountMenuLoyaltyNoAccountGoldTile from './AccountMenuLoyaltyNoAccountGoldTile'

interface Props {
  eligibilityTier: App.LoyaltyTier
  onLinkClick: () => void
  config: App.LoyaltyConfig
}

function AccountMenuLoyaltyNoAccountDetailsTiles(props: Props) {
  const { eligibilityTier, onLinkClick, config } = props
  return (<>
    {eligibilityTier === 'bronze' &&
      <AccountMenuLoyaltyNoAccountBronzeTile
        onLinkClick={onLinkClick}
      />}
    {eligibilityTier === 'silver' &&
      <AccountMenuLoyaltyNoAccountSilverTile
        onLinkClick={onLinkClick}
        config={config}
      />}
    {eligibilityTier === 'gold' &&
      <AccountMenuLoyaltyNoAccountGoldTile
        onLinkClick={onLinkClick}
        config={config}
      />}
  </>)
}

export default AccountMenuLoyaltyNoAccountDetailsTiles
